import { useMemo } from 'react'
import { corePlugins } from '~ui-components/components/molecules/TextEditor/plugins'

const usePlugins = (plugins) => {
  return useMemo(() => corePlugins(plugins), [plugins])
}

export { usePlugins }
